import { BaseApi } from "./base.api";
import {
  TIntegrationOffice,
  TIntegrationOfficeRelation,
  TIntegrationOfficeRelationData,
} from "types/integration-sync-office.type";
import {
  TJupixOfficeApiData,
  TJupixOfficeRelationApiData,
} from "types/jupix.type";
import {
  jupixOfficeDataToIntegrationOfficeDataMapper,
  mapJupixOfficeRelationsToIntegrationOfficeRelations,
  mapIntegrationOfficeRelationsToJupixOfficeRelations,
} from "utils/jupix.utils";

export class AccountJupixApi extends BaseApi {
  async connect(accountId: number): Promise<void> {
    await this.post(`/accounts/${accountId}/jupix/connect`);
  }

  async fetchAccountOffices(accountId: number): Promise<TIntegrationOffice[]> {
    const offices: TJupixOfficeApiData[] = await this.get(
      `/accounts/${accountId}/jupix/jupix-offices`
    );
    return jupixOfficeDataToIntegrationOfficeDataMapper(offices);
  }

  async fetchAccountOfficeRelations(
    accountId: number
  ): Promise<TIntegrationOfficeRelation[]> {
    const relations: TJupixOfficeRelationApiData[] = await this.get(
      `/accounts/${accountId}/jupix/office-relations`
    );
    return mapJupixOfficeRelationsToIntegrationOfficeRelations(relations);
  }

  async updateSyncedAccountOffices(
    accountId: number,
    relationsData: TIntegrationOfficeRelationData[]
  ) {
    await this.post(`/accounts/${accountId}/jupix/office-relations`, {
      items: mapIntegrationOfficeRelationsToJupixOfficeRelations(relationsData),
    });
  }
}
